import styled from 'styled-components';
import { UrlFilters } from '@elementary/common-ui/hooks/useUrlFilters';
import { ThresholdLevel } from '../../types';
import Card from '../shared/Card';
import HighScoreOverTime from './HighScoreOverTime';
import TotalHealthScore from './TotalHealthScore';
import TotalTests from './TotalTests';

const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr) 3fr;
  gap: 4%;

  [data-narrow] & {
    grid-template-columns: 1fr 1fr;

    > :nth-child(3) {
      grid-column: 1 / -1;
    }
  }
`;

type Props = {
  totalScore: {
    percent: number;
    value: ThresholdLevel;
    thresholds: {
      low: number;
      medium: number;
    };
  };
  tests: {
    total: number;
  };
  scoreOverTime: Array<{
    date: string;
    score: number;
  }>;
  onTotalHealthScoreFormulaChange: () => void;
  selectedFilters: UrlFilters | undefined;
};

const DataHealthSummary = ({
  totalScore,
  tests,
  scoreOverTime,
  onTotalHealthScoreFormulaChange,
  selectedFilters,
}: Props) => (
  <Card>
    <Grid>
      <TotalHealthScore
        value={totalScore.percent}
        thresholdLevel={totalScore.value}
        thresholds={totalScore.thresholds}
        onTotalHealthScoreFormulaChange={onTotalHealthScoreFormulaChange}
      />

      <TotalTests total={tests.total} selectedFilters={selectedFilters} />

      <HighScoreOverTime
        scores={scoreOverTime}
        lowThreshold={totalScore.thresholds.low}
        mediumThreshold={totalScore.thresholds.medium}
      />
    </Grid>
  </Card>
);

export default DataHealthSummary;
